import React from 'react'
import red from '../assets/red.png';
import blue from '../assets/blue.png';
import pink from '../assets/pink.png';


const Diamonds = () => {
    return (
        <div className='diam flex centerflex vertcenter secPad'>
            <div className="container-lg flexcol centerflex vertcenter">
                <h2>Rarity Rankings</h2>
                <div className="flex flexrow centerflex vertcenter space diamondsDiv">
                    <div className="cardDiam blueD">
                        <img className='shine' src={blue} alt="Blue Diamond" />
                        <span>Blue Diamond</span>
                    </div>
                    <div className="cardDiam pinkD">
                        <img className='shine' src={pink} alt="Pink Diamond" />
                        <span>Pink Diamond</span>
                    </div>
                    <div className="cardDiam redD">
                        <img className='shine' src={red} alt="Red Diamond" />
                        <span>Red Diamond</span>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default Diamonds
